import React from "react"
import { MainCP } from "../../Components/nivel-agrado-rostros-publicitarios-2024/MainCP"

const ViewNivelAgradoRostrosPublicitarios2024: React.FC = () => <MainCP/>

export default ViewNivelAgradoRostrosPublicitarios2024